module.exports = __webpack_public_path__ + "img/ont.289a8468.svg";